import { EnumClosingCostType } from '../types/settings';
import { ILoanColumn } from '../types/reports';
import { formatAmount } from './formatAmount';

const calculateLoanPercentage = (loan: ILoanColumn, percentage: number): number => {
  if (!percentage || !loan?.loanAmount?.value) return 0

  const value = (percentage / 100) * parseFloat(loan?.loanAmountWithUip?.value as string);

  return parseFloat(formatAmount(value));
};

const calculate15DaysPrepaidInterest = (
  loan: ILoanColumn,
  interestRate: { value: string },
  daysCollected: number
): number => {

  if (!loan?.loanAmount?.value || !interestRate) return 0

  const dailyInterest =
    (parseFloat(loan?.loanAmountWithUip?.value as string) * (parseFloat(interestRate?.value) / 100)) / 365;

  const formatedDailyInterest = formatAmount(dailyInterest)

  return parseFloat(formatedDailyInterest) * daysCollected;
}

const calculateLoanPercentageOfPurchase = (purchasePrice: { value: string }, percentage: number) => {
  if (!percentage || !purchasePrice?.value) return 0

  const value = (percentage / 100) * parseFloat(purchasePrice?.value);

  return parseFloat(formatAmount(value));
};

const calculateLoanPropertyTaxes = (propertyTaxes: { value: string }, propertyTaxesMonthsCollected: number): number => {
  if (!propertyTaxes?.value || !propertyTaxesMonthsCollected) return 0

  const value = parseFloat(propertyTaxes.value) * propertyTaxesMonthsCollected

  return parseFloat(formatAmount(value));
};

const calculateLoanHomeownersInsurance = (
  homeInsurance: { value: string },
  propertyTaxesMonthsCollected: number
): number => {
  if (!homeInsurance?.value || !propertyTaxesMonthsCollected) return 0

  const value = parseFloat(homeInsurance.value) * propertyTaxesMonthsCollected

  return parseFloat(formatAmount(value));
};

export const calculateLoanClosingCostAmount = (
  loan: ILoanColumn,
  type: EnumClosingCostType,
  amount: number,
  propertyTaxesMonthsCollected: number,
  daysCollected: number,
) => {
  switch(type) {
    case EnumClosingCostType.flatFee:
      return amount;
    case EnumClosingCostType.percentageOfLoanAmount:
      return calculateLoanPercentage(loan, amount);
    case EnumClosingCostType.prepaidInterest15Days:
      return calculate15DaysPrepaidInterest(loan, loan.interestRate as { value: string }, daysCollected);
    case EnumClosingCostType.percentageOfPurchasePrice:
      return calculateLoanPercentageOfPurchase(loan?.purchasePrice as { value: string }, amount);
    case EnumClosingCostType.propertyTaxes:
      return calculateLoanPropertyTaxes(loan?.propertyTaxes as { value: string }, propertyTaxesMonthsCollected);
    case EnumClosingCostType.homeownersInsurance:
      return calculateLoanHomeownersInsurance(loan?.homeInsurance as { value: string }, propertyTaxesMonthsCollected);
    default:
      return 0;
  }
}
